import router from './router'
import $x from '../js/$x'
import store from '../store/index'
import getMenuRoutesMap from './menuRoutesMap.js';
import getMainRoutes from './mainRoutes.js';

var haveRouter, routerTabs;
//横屏全屏显示的页面
const fullScreenPath = [
    '/fullScreenChart',
    '/arrangeWork'
];

router.beforeEach((to, from, next) => {
    if (!haveRouter) {
        //刷新页面或其他页面返回,只执行一次
        $x.post('home/getHomeUrl', {})
            .then(res => {
                haveRouter = true;
                routerTabs = res || [];
                router.addRoutes(getMainRoutes())
                //获取登录用户角色
                addDynamicRoutes(routerTabs)
                next({ ...to, replace: true })
                store.dispatch('setRouterTabs', res);
            })
    } else {
        if (to.path === '/back') {
            var defaultRoute = { path: routerTabs[0].url, query: {} }
            var route = Object.assign(defaultRoute, $x.storage.getObj('jumpOutPars'))
            route.query.isBack = true;

            next(route)
            return
        }

        if (fullScreenPath.indexOf(from.path) > -1) {
            store.dispatch('setFullScreen', false)
            store.dispatch('setShowBar', { head: true, foot: true })
        }

        //keepAlive只用于员工中心
        //返回时除了router.js不会触发任何状态监控，手动改变值触发页面变动
        if (to.meta.keepAlive) {
            store.dispatch('setScrollTop', store.state.scrollTop - 1)
        }

        //刷新页面或其他页面返回,只执行一次
        if (!$x.userInfo.account && to.path !== '/login') {
            $x.axios.doLogin()
        } else {
            //第一次登录进来时，退出登录时会清空
            const loginState = $x.storage.getObj('loginState');
            if (loginState == null && routerTabs.length) {
                $x.storage.setObj('loginState', 1)
                next({ path: routerTabs[0].url })
            } else {
                next()
            }
        }
    }
})

function getRouter(res) {
    var routes = [];
    var map = getMenuRoutesMap()
    res.map(menu => {
        if (map[menu.url]) {
            routes.push(...map[menu.url])
        }
    });
    return routes
}

function addDynamicRoutes(res) {
    const routers = getRouter(res);
    router.addRoutes(routers);
    //动态添加路由后，打印出router.options.routes为空，需要手动赋值
    router.options.routes.push(...routers)
}
// router.afterEach((to) => {
//
// })

